module.exports = __webpack_public_path__ + "phonetracking.svg?0bb071f4182a7474f64b1d1320dc8d52";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/icons/phonetracking.svg
// module id = 115
// module chunks = 0